/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdilocNojoins.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/ediloc-nojoins";

export class AutogenModelEdilocNojoins<RowType extends ModelRow> extends Endpoint<RowType, RowEdilocNojoinsFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdilocNojoins extends ModelRow<RowEdilocNojoinsFields> {
	constructor(values?: Partial<RowEdilocNojoinsFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdilocNojoinsFields {
	company_id: string;
	customer_id: string;
	edi_location: string;
	edi_location_qual: string;
	id: string;
	location_id: string;
	location_type: string;
	partner_id: string;
	version: string;
}

